import Link from "next/link";
import { VFC } from "react";

interface StepProgressBarProps {
  step: number;
}

export const StepProgressBar: VFC<StepProgressBarProps> = ({ step }) => {
  return (
    <div className="p-steps">
      <div className="p-steps__inner">
        <ul>
          <li className={step == 1 ? "is-cr" : ""}>
            <span>寄付</span>
          </li>
          <li className={step == 2 ? "is-cr" : ""}>
            <span>
              基本
              <br className="u-sp" />
              情報
            </span>
          </li>
          <li className={step == 3 ? "is-cr" : ""}>
            <span>
              支払い
              <br className="u-sp" />
              方法
            </span>
          </li>
          <li className={step == 4 ? "is-cr" : ""}>
            <span>ご確認</span>
          </li>
          <li className={step == 5 ? "is-cr" : ""}>
            <span>完了</span>
          </li>
        </ul>
      </div>
    </div>
  );
};
